import http from "../http-common-2";

class PlanService {
  getAllplans() {
    return http.get(`/paidplans/all`);
  }

}
export default new PlanService();